"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const match_sorter_1 = require("match-sorter");
const valueIsArray_1 = __importDefault(require("../../typeAssertions/valueIsArray"));
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const searchInObjectBuilder = () => ({ functionId, callbacks, executeProcesses, entryVars: { object, path, valueToMatch, }, }) => {
    if (!(0, valueIsString_1.default)(path)
        || !(0, valueIsString_1.default)(valueToMatch)) {
        executeProcesses(functionId, callbacks.onError, 'Invalid definition');
        return;
    }
    if (!(0, valueIsRecord_1.default)(object) && !(0, valueIsArray_1.default)(object)) {
        executeProcesses(functionId, callbacks.onError, 'Invalid data to search');
        return;
    }
    const convertToArray = Object.entries(object).map(([id, data]) => {
        if (typeof data === 'object') {
            return Object.assign(Object.assign({}, data), { id });
        }
        return { data, id };
    });
    const match = (0, match_sorter_1.matchSorter)(convertToArray, valueToMatch, { keys: path.split('.') });
    if (match.length > 0) {
        executeProcesses(functionId, callbacks.onMatch, match);
        return;
    }
    executeProcesses(functionId, callbacks.onEmpty, match);
};
exports.default = searchInObjectBuilder;
